var Fancyapps = require('@fancyapps/ui');

// Fancybox renders its close buttons (toolbar + in-slide) from a hard-coded template
// with only a title attribute, and adds the in-slide one as each slide's content loads.
// Watch the container so every close button gets an accessible name.
var labelCloseButtons = function (container) {
	container
		.querySelectorAll('.f-button[data-fancybox-close]:not([aria-label])')
		.forEach(function (button) {
			button.setAttribute('aria-label', 'close');
		});
};

var closeButtonObserver = null;

var escapeAttr = function (value) {
	return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
};

var squish = function (value) {
	return (value || '').replace(/\s+/g, ' ').trim();
};

// Label for the <dialog>: a heading inside the lightbox content if there is one,
// otherwise the trigger's visible text (e.g. "Hear Kasson's Story"), its image alt
// (video thumbnails), or its title. Avoids the trigger's aria-label, which can carry
// "- opens in a new tab".
var dialogLabelAttr = function (trigger) {
	if (!trigger) {
		return '';
	}

	var src = trigger.getAttribute('data-src') || trigger.getAttribute('href') || '';
	if (src.charAt(0) === '#' && src.length > 1) {
		var content = document.getElementById(src.slice(1));
		var heading = content && content.querySelector('h1, h2, h3, h4, h5, h6');
		if (heading && squish(heading.textContent)) {
			if (!heading.id) {
				heading.id = src.slice(1) + '-label';
			}
			return ' aria-labelledby="' + escapeAttr(heading.id) + '"';
		}
	}

	var image = trigger.querySelector('img[alt]');
	var label =
		squish(trigger.textContent) ||
		squish(image && image.getAttribute('alt')) ||
		squish(trigger.getAttribute('title'));

	return label ? ' aria-label="' + escapeAttr(label) + '"' : '';
};

module.exports = {
	init: function () {
		var defaultTpl = Fancyapps.Fancybox.getDefaults().mainTpl;

		Fancyapps.Fancybox.bind('[data-fancybox]', {
			// Fancybox builds the <dialog> from this template before showModal(), so
			// the label, role and aria-modal are on the dialog from the moment it's
			// created. A showModal() <dialog> already has both semantics; they're
			// stated explicitly for the audit and older assistive tech.
			mainTpl: function (fancybox) {
				var labelAttr = dialogLabelAttr(fancybox.getOptions().triggerEl);
				return defaultTpl.replace(/<dialog\b/, '<dialog role="dialog" aria-modal="true"' + labelAttr);
			},
			on: {
				ready: function (fancybox) {
					var container = fancybox.getContainer();
					if (!container) return;
					labelCloseButtons(container);
					closeButtonObserver = new MutationObserver(function () {
						labelCloseButtons(container);
					});
					closeButtonObserver.observe(container, {
						childList: true,
						subtree: true,
					});
				},
				destroy: function () {
					if (closeButtonObserver) {
						closeButtonObserver.disconnect();
						closeButtonObserver = null;
					}
				},
			},
		});
	},
};
